export const acceptedMimeTypes = {
  IMAGE: {
    "image/jpg": [".jpg"],
    "image/jpeg": [".jpeg"],
    "image/png": [".png"],
    "image/webp": [".webp"],
    // "image/tiff": [".tiff"], // TODO: Disabled for now until Uploader will start supporting working files
  },
  VIDEO: {
    "video/mp4": [".mp4"],
    "video/m4v": [".m4v"],
    "video/quicktime": [".mov"],
  },
  DOCUMENT: {
    "application/pdf": [".pdf"],
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [
      ".xlsx",
    ],
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [
      ".docx",
    ],
  },
  DELIVERY: {},
};
